import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Card, Button, Row, Col, Typography, Empty, Tag } from "antd";
import { UserOutlined } from "@ant-design/icons";
import Utilities from "../../dependencies/custom/react-utilities";
import useDrawer from "../../hooks/drawer";
import useAdd from "../../hooks/add";
import useTable from "../../hooks/table";
import Settings from "../../dependencies/custom/settings";
import dayjs from "dayjs";
const { Title, Text } = Typography;

export default function MyAttendance() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [applications, setApplications] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState();

  const table = useTable(
    {
      pagination: {
        current: 1,
        pageSize: 20,
        hideOnSinglePage: true,
      },
    },
    undefined,
    undefined,
    undefined,
    undefined,
    "id",
    {},
    {},
  );

  useEffect(() => {
    setShow(applications?.some((v) => v?.status?.toLowerCase() == "admitted"));

    table.setColumns([
      {
        title: "Name",
        dataIndex: "student_name",
      },
      {
        title: "Term",
        dataIndex: "term",
      },
      {
        title: "Academic Year",
        dataIndex: "academicYear",
      },
      {
        title: "Date",
        dataIndex: "generatedAt",
        render(v, record) {
          return dayjs(v)?.format("DD/MM/YYYY");
        },
      },
      {
        title: "Report",
        key: "report",
        render(v, record) {
          return (
            <Button
              icon={<i className="fas fa-file" />}
              type="primary"
              onClick={(e) => Utilities.openPopup(record?.reportFile)}
            >
              View
            </Button>
          );
        },
      },
    ]);
  }, [applications]);

  useEffect(() => {
    boostrap2();
  }, []);

  async function boostrap2() {
    const res = await Utilities.fetchWithAuth(
      "GET",
      Settings.urls.enrollment?.related_applications,
      undefined,
      navigate,
    );
    if (res?.ok && applications?.length <= 0) {
      setApplications(res?.data);
    } else {
      Utilities.showNotification(undefined, res?.msg);
    }
  }

  async function getDetails(child) {
    if (!child || !child?.student) return;
    setSelectedStudent(child?.student);
    // const studentID = child?.student?.id;
    const studentID = 20255002; //20255940;
    table.setData([]);
    table.setLoading(true);
    const manualDate = "";
    const res = await Utilities.fetchWithAuth(
      "GET",
      `${Settings?.urls?.academics?.student_attendance}/${studentID}${manualDate ? `?manualDate=${manualDate}` : ""}`,
      undefined,
      navigate,
    );
    // console.log(res);

    if (res?.ok) {
      const data = res?.data;
      const groupByClassGroup = Utilities.groupBy(data, "classGroup");
      console.log(groupByClassGroup);
      // table.setData(res?.data);
    } else {
      Utilities.showNotification(undefined, res?.msg);
    }
    table.setLoading(false);
  }

  return (
    <div className="p-6">
      <div className="mb-3">
        <Title level={3}>My Attendance Report</Title>
        <Text type="secondary">
          {show
            ? "Select child to view attendance report"
            : "No child has been admitted for attendance report"}
        </Text>
      </div>

      <Row gutter={[16, 16]} className="mt-6">
        <Col xs={24} sm={24} md={12} lg={12}>
          <Row gutter={[16, 16]}>
            {applications?.map(
              (app) =>
                app?.status?.toLowerCase() == "admitted" && (
                  <Col key={app?.admissionID} xs={24} sm={24} md={12} lg={12}>
                    <Card
                      hoverable
                      className="rounded-2xl shadow"
                      actions={[
                        <Button
                          onClick={() => getDetails(app)}
                          icon={<i className="fas fa-eye" />}
                          type="primary"
                        >
                          Get Reports
                        </Button>,
                      ]}
                    >
                      <div className="flex items-center gap-3 mb-2">
                        <UserOutlined style={{ fontSize: 28 }} />
                        <Title level={5} className="mb-0">
                          {app?.student?.firstName} {app?.student?.lastName}
                        </Title>
                      </div>
                      <Tag color="blue" className="mt-2">
                        {app?.student?.className}
                      </Tag>
                    </Card>
                  </Col>
                ),
            )}
          </Row>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          {show && (
            <Card
              title={
                selectedStudent
                  ? `Reports for ${selectedStudent?.firstName} ${selectedStudent?.lastName} (${selectedStudent?.id})`
                  : "No student has been selected yet..."
              }
              hoverable
              className="rounded-2xl shadow criclebox tablespace"
            >
              {table.table}
            </Card>
          )}
        </Col>
      </Row>
    </div>
  );
}
